import { gql } from '@apollo/client'

export default gql`
  fragment CourseLessonPreview on CourseLesson {
    id
    title
    position
  }
`
